import { useEffect } from "react";
import { 
  fetchSettingsRequest, 
  receivePublicSettings,
  receivePrivateSettings,
  receiveSettingsError 
} from "../actions/settings";
import { default as settingsService } from "../services/settings";
import { Settings } from "../types/settings";
import { useAppDispatch, useAppSelector } from "@/hooks";
export interface IReduxSettings {
  publicData: Settings | null;
  privateData: Settings | null;
  isFetching: boolean;
  loaded: boolean;
  error: boolean;
}

const useSettingsProvider = () => {

  const dispatch = useAppDispatch();
  const isAuthenticated = useAppSelector(state => state.auth?.isAuthenticated);
  const settings = useAppSelector(state => state.settings) as IReduxSettings;

  const fetchSettings = () => {
    dispatch(fetchSettingsRequest())
    settingsService.fetchSettings()
    .then(res => {
      res.target = "public";
      dispatch(receivePublicSettings(res));
    }).catch(err => {
      dispatch(receiveSettingsError())
    })
  }

  const fetchUserSettings = () => {
    dispatch(fetchSettingsRequest())
    settingsService.fetchUserSettings()
    .then(res => {
      res.target = "user";
      dispatch(receivePrivateSettings(res));
    }).catch(err => {
      dispatch(receiveSettingsError())
    })
  }

  useEffect(() => {
    if (settings.publicData == null) {
      fetchSettings()
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      fetchUserSettings();
    }

  }, [isAuthenticated]);

  return {
    settings
  }
  
}

export default useSettingsProvider;
